skrilla.service('sportEventService', function(srefService){

    sportEventUrl = function(event, clickEvent) {
        if (event.eventType === 'MATCH') {
            return srefService.go("matchDetails", {id: event.eventId, sport: event.sport}, clickEvent);
        } else if (event.eventType === 'SEASON') {
            return srefService.go("seasonDetails", {id: event.eventId, sport: event.sport}, clickEvent);
        } else if (event.eventType === 'TOURNAMENT') {
            return srefService.go("tournamentDetails", {id: event.eventId, sport: event.sport}, clickEvent);
        }
    }

    return {
        sportEventUrl,
    };
});

